<template>
  <v-card class="packaging-details">
    <v-row
      class="loader fill-height py-6"
      align="center"
      justify="center"
      v-if="isPackagingDetailFormLoading || retrievingEditExportJob"
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <div v-else>
      <v-card-text class="px-8 py-6">
        <div class="packaging-details-tab">
          <div class="packaging-details-tab__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
            <div class="packaging-details-tab__header--title black--text fs-25 fw-600">
              Packaging Details
            </div>
          </div>
          <div class="packaging-details-tab__table mt-2"></div>
        </div>
        <v-row>
          <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
            <div>
              <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
                <v-row>
                  <v-col cols="12" :xs="12" :sm="12" :md="4" :lg="4">
                    <TextField
                      v-model="from"
                      rules="required|max:5"
                      type="number"
                      showIcons
                      :showOnlyErrorIcons="true"
                      :loading="isPackagingDetailFormLoading || savingExportJob"
                      label="From"
                    />
                  </v-col>
                  <v-col cols="12" :xs="12" :sm="12" :md="4" :lg="4">
                    <TextField
                      v-model="to"
                      rules="required|max:5"
                      type="number"
                      showIcons
                      :showOnlyErrorIcons="true"
                      :loading="isPackagingDetailFormLoading || savingExportJob"
                      label="To"
                    />
                  </v-col>
                  <v-col cols="12" :xs="12" :sm="12" :md="4" :lg="4">
                    <TextField
                      v-model="packingNo"
                      rules="required|max:3"
                      showIcons
                      :showOnlyErrorIcons="true"
                      :loading="isPackagingDetailFormLoading || savingExportJob"
                      label="Packing Details Code"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                    <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
                      <v-btn
                        width="140"
                        color="info"
                        large
                        class="white--text"
                        :loading="isPackagingDetailFormLoading || savingExportJob"
                        @click="$emit('change-tab', 0)"
                      >
                        <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                        <span class="font-weight-bold fs-15">Previous</span>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                    <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                      <v-btn
                        width="140"
                        color="button-primary"
                        large
                        class="white--text"
                        :loading="isPackagingDetailFormLoading || savingExportJob"
                        @click="passes(savePackagingDetails)"
                      >
                        <span class="font-weight-bold fs-15">Save</span>
                      </v-btn>
                      <v-btn
                        width="140"
                        color="info"
                        large
                        class="ml-4 white--text"
                        :loading="isPackagingDetailFormLoading || savingExportJob"
                        @click="$router.push({ name: 'dashboard.export.supporting-doc' })"
                      >
                        <span class="font-weight-bold fs-15">Next</span>
                        <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import TextField from "@/components/TextField";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "PackagingDetailsTab",
  components: {
    ValidationObserver,
    TextField
  },
  data() {
    return {
      isPackagingDetailFormLoading: false
    };
  },
  mounted() {
    this.retrievePackingList();
  },
  computed: {
    tableHeaders() {
      return [
        {
          text: "From",
          value: "from"
        },
        {
          text: "To",
          value: "to"
        },
        {
          text: "Packet Code",
          value: "packingCode"
        },
        {
          text: "Action",
          value: "action"
        }
      ];
    },
    from: {
      get() {
        return this.$store.state.ExportModuleStore.packingList.packingNoFrom;
      },
      set(value) {
        this.$store.commit(MT.SET_PACKING_LIST_PACKING_NO_FROM, { value });
      }
    },
    to: {
      get() {
        return this.$store.state.ExportModuleStore.packingList.packingNoTo;
      },
      set(value) {
        this.$store.commit(MT.SET_PACKING_LIST_PACKING_NO_TO, { value });
      }
    },
    packingNo: {
      get() {
        return this.$store.state.ExportModuleStore.packingList.packingCode;
      },
      set(value) {
        this.$store.commit(MT.SET_PACKING_LIST_PACKING_CODE, { value });
      }
    }
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    makeFieldsNull() {
      this.from = null;
      this.to = null;
      this.packingNo = null;
      return;
    },
    retrievePackingList() {
      const packingList = this.$store.getters.exportJob.packingLists.find(
        packingList => packingList.invoiceSrNo === this.invoiceSrNo
      );
      if (packingList !== undefined) {
        this.$store.commit(MT.SET_PACKING_LIST_FROM_EXPORT_JOB, packingList);
      }
      return;
    },

    savePackagingDetails() {
      const packingList = { ...this.$store.getters.packingList };
      this.$store.commit(MT.SET_PACKING_LIST_IN_EXPORT_JOB, packingList);
      this.saveExportJob();
    }
  }
};
</script>
<style lang="scss">
.packaging-details-tab {
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
